<form [formGroup]="form" class="form edit-conditions-on-custom-fields-modal">
  <app-select
    [labelKey]="'parameters/quick_replies/details/conditions_on_custom_fields/selected_custom_field'"
    [control]="form.get('selectedCustomField')"
    [items]="customFields"></app-select>

  <app-select
    [labelKey]="'parameters/quick_replies/details/details/conditions_on_custom_fields/label'"
    [control]="form.get('selectedCondition')"
    [items]="conditionsDropdownItems"></app-select>

  <app-select
    *ngIf="type === 'datetime' || type === 'date'"
    [enableTypeahead]="true"
    [control]="dateForm.controls.timezone"
    [items]="timezoneItems"
    [noFloatingLabel]="true"
    [labelKey]="'date-time-modal/timezone'">
  </app-select>

  <div
    class="example-fields"
    [ngSwitch]="type"
    *ngIf="
      form.value.selectedCondition !== CustomFieldConditionEnum.IS_NOT_NULL &&
      form.value.selectedCondition !== CustomFieldConditionEnum.IS_NULL
    ">
    <mat-form-field *ngSwitchCase="'integer'">
      <mat-label
        translate="parameters/quick_replies/details/details/conditions_on_custom_fields/condition_value"></mat-label>
      <input type="number" matInput formControlName="comparedValue" />
    </mat-form-field>

    <mat-form-field *ngSwitchCase="'date'">
      <mat-label
        translate="parameters/quick_replies/details/details/conditions_on_custom_fields/condition_value"></mat-label>
      <input matInput [matDatepicker]="picker" [formControl]="$any(dateForm.controls.date)" />
      <mat-datepicker #picker></mat-datepicker>
      <mat-datepicker-toggle
        [disabled]="dateForm.controls.date.disabled"
        matSuffix
        [for]="picker"></mat-datepicker-toggle>
    </mat-form-field>

    <mat-form-field *ngSwitchCase="'datetime'">
      <mat-label
        translate="parameters/quick_replies/details/details/conditions_on_custom_fields/condition_value"></mat-label>
      <input matInput [matDatepicker]="picker" [formControl]="$any(dateForm.controls.date)" />
      <mat-datepicker #picker></mat-datepicker>
      <mat-datepicker-toggle
        [disabled]="dateForm.controls.date.disabled"
        matSuffix
        [for]="picker"></mat-datepicker-toggle>
    </mat-form-field>

    <ngx-mat-timepicker-field
      *ngSwitchCase="'datetime'"
      (timeChanged)="updateTime($event)"
      [defaultTime]="startHours"
      [format]="24"></ngx-mat-timepicker-field>

    <app-select
      *ngSwitchCase="'boolean'"
      labelKey="parameters/quick_replies/details/details/conditions_on_custom_fields/condition_value"
      [control]="form.get('comparedValue')"
      [items]="booleanItems">
    </app-select>

    <app-select
      *ngSwitchCase="'enum'"
      labelKey="parameters/quick_replies/details/details/conditions_on_custom_fields/condition_value"
      [control]="form.get('comparedValue')"
      [items]="customFieldAllowedItems">
    </app-select>

    <app-select
      *ngSwitchCase="'multipicklist'"
      labelKey="parameters/quick_replies/details/details/conditions_on_custom_fields/condition_value"
      [control]="form.get('comparedValue')"
      [items]="customFieldAllowedItems">
    </app-select>

    <mat-form-field *ngSwitchDefault>
      <mat-label
        translate="parameters/quick_replies/details/details/conditions_on_custom_fields/condition_value"></mat-label>
      <input type="text" matInput formControlName="comparedValue" />
    </mat-form-field>
  </div>
</form>
